module.exports = __webpack_public_path__ + "media/pages/childrens_church-bfd0b045.jpg";